<template lang="pug">
  .map-wrapper
    .top-bar
      .buttons
        img.cursor-pointer(
          :style="{ opacity: soilParam === 'humidity' ? 1 : 0.3, transform: soilParam === 'humidity' ? 'scale(1.2)' : 'scale(1)', filter: soilParam === 'humidity' ? 'drop-shadow(0 0 3px #7a7a7a)' : 'none'}"
          src="@assets/client/overview/humidity2.png"
          :title="$t('overview.map.humidity')"
          @click="showInfoBy('humidity')"
        )
        img.cursor-pointer.ml-1(
          :style="{ opacity: soilParam === 'temperature' ? 1 : 0.3, transform: soilParam === 'temperature' ? 'scale(1.2)' : 'scale(1)', filter: soilParam === 'temperature' ? 'drop-shadow(0 0 3px #7a7a7a)' : 'none'}"
          src="@assets/client/overview/temperature.png"
          :title="$t('overview.map.temperature')"
          @click="showInfoBy('temperature')"
        )
        img.cursor-pointer.ml-1(
          :style="{ opacity: soilParam === 'conductivity' ? 1 : 0.3, transform: soilParam === 'conductivity' ? 'scale(1.2)' : 'scale(1)', filter: soilParam === 'conductivity' ? 'drop-shadow(0 0 3px #7a7a7a)' : 'none'}"
          src="@assets/client/overview/conductivity.png"
          :title="$t('overview.map.conductivity')"
          @click="showInfoBy('conductivity')"
        )
        img.cursor-pointer.ml-1(
          :style="{ opacity: soilParam === 'ph' ? 1 : 0.3, transform: soilParam === 'ph' ? 'scale(1.2)' : 'scale(1)', filter: soilParam === 'ph' ? 'drop-shadow(0 0 3px #7a7a7a)' : 'none'}"
          src="@assets/client/overview/ph.png"
          :title="$t('overview.map.ph')"
          @click="showInfoBy('ph')"
        )
        img.cursor-pointer.ml-1(
          :style="{ opacity: soilParam === 'nitrogen' ? 1 : 0.3, transform: soilParam === 'nitrogen' ? 'scale(1.2)' : 'scale(1)', filter: soilParam === 'nitrogen' ? 'drop-shadow(0 0 3px #7a7a7a)' : 'none'}"
          src="@assets/client/overview/nitrogen.png"
          :title="$t('overview.map.nitrogen')"
          @click="showInfoBy('nitrogen')"
        )
        img.cursor-pointer.ml-1(
          :style="{ opacity: soilParam === 'phosphorus' ? 1 : 0.3, transform: soilParam === 'phosphorus' ? 'scale(1.2)' : 'scale(1)', filter: soilParam === 'phosphorus' ? 'drop-shadow(0 0 3px #7a7a7a)' : 'none'}"
          src="@assets/client/overview/phosphorus.png"
          :title="$t('overview.map.phosphorus')"
          @click="showInfoBy('phosphorus')"
        )
        img.cursor-pointer.ml-1(
          :style="{ opacity: soilParam === 'potassium' ? 1 : 0.3, transform: soilParam === 'potassium' ? 'scale(1.2)' : 'scale(1)', filter: soilParam === 'potassium' ? 'drop-shadow(0 0 3px #7a7a7a)' : 'none'}"
          src="@assets/client/overview/potassium.png"
          :title="$t('overview.map.potassium')"
          @click="showInfoBy('potassium')"
        )
      .legend
        .legend-item
          img.legend-icon(
            src="@assets/map/soil-sensor.svg",
          )
          span {{ $t('overview.map.legend.sensor_optimal_params') }}
        .legend-item
          img.legend-icon(
            src="@assets/map/soil-sensor-suboptimal.svg",
          )
          span {{ $t('overview.map.legend.sensor_suboptimal_params') }}
    ClientGoogleMaps(
      :dialogName="'Overview'"
      :sensors="sensors"
      :fields="fields"
      :soilParam="soilParam"
    )

</template>

<script>
import { mapState, mapActions } from "vuex";
import ClientGoogleMaps from "@components/client/overview/ClientGoogleMaps";

export default {
  name:"OverviewMap",

  components: {
    ClientGoogleMaps,
  },
  props: {
    sensors: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      soilParam: "humidity",
    };
  },

  computed: {
    ...mapState("auth", ["user"]),
  },

  methods: {
    ...mapActions("field", ["getFieldInfoSettings"]),

    async showInfoBy(param){
      this.soilParam = param;
    },
  },
};
</script>

